import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PaymentHistory } from '../../models/payment/payment-history.interface';

@Injectable({ providedIn: 'root' })
export class PaymentService {
	private readonly relativeUrl = 'applications';

	constructor(private readonly http: HttpClient) {}

	getPaymentHistory(applicationId: number): Observable<PaymentHistory> {
		return this.http.get<PaymentHistory>(
			`${this.relativeUrl}/${applicationId.toString()}/payment-history`
		);
	}
}
